/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import VueBase from '@/pages/vue-base'

export type BreadCrumb = {
  text: string
  disabled?: boolean
  to?: string
  exact?: boolean
}

export default abstract class PageBase extends VueBase {
  abstract get breadcrumbs(): Array<BreadCrumb>
  mounted(): void {
    this.setBreadcrumbs(this.breadcrumbs)
  }
}